import { useMutation, useQueryClient } from '@tanstack/react-query';

import { resetCondutor } from '@services/detran/condutor.service';

export interface RestaurarCondutorInput {
  cpf: string;
}

/**
 * Devolve o CPF ao cadastro base do DETRAN.
 *
 * Existe para a demonstração poder ser repetida sem reiniciar o mock. Como
 * qualquer alteração feita aqui, só chega ao Perfil do Cidadão na próxima
 * coleta do DETRAN.
 */
export function useRestaurarCondutor() {
  const queryClient = useQueryClient();

  return useMutation<void, Error, RestaurarCondutorInput>({
    mutationFn: async ({ cpf }) => {
      await resetCondutor(cpf);
    },
    onSuccess: (_result, { cpf }) => {
      queryClient.invalidateQueries({ queryKey: ['condutor', cpf] });
    },
  });
}
